import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { ConsultantResource, User, UserType } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection } from 'elbuild-ui-lib-core';
import { Subscription, Observable, combineLatest, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConsultantresourceEditComponent } from '../consultantresource-edit/consultantresource-edit.component';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-consultantresource-list',
	templateUrl: './consultantresource-list.component.html',
	styleUrls: ['./consultantresource-list.component.scss']
})
export class ConsultantresourceListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: ConsultantResource[];

	advancedSearch: Search = new Search('consultantresource', `concat(fname,'',lname)`, 'consultantresource');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	consultantid: number;
	loggedUser: User;
	subcription: Subscription;

	constructor(
		private resourceService: CrudService<ConsultantResource>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();
		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}

			this.search(data[0]);

		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.consultantid) {
			this.advancedSearch.addSimpleFilter('consultantid', this.consultantid);
		}

		const datarequest = this.resourceService.searchEntities(ConsultantResource, 'consultantresource', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.resourceService.countEntities(ConsultantResource, 'consultantresource', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any) {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.router.navigate([`/consultant/resource/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			}
		}
	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: ConsultantResource, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-resource-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.resourceService.deleteEntity(ConsultantResource, 'consultantresource', row).subscribe(() => {
					this.translateService.get(['labels.resource-deleted', 'labels.consultantresources']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.resource-deleted'], messages['labels.consultantresources']);
						this.load();
					});
				});
			}
		});
	}


	edit(resourceid?: number) {
		const modal = this.modalService.open(ConsultantresourceEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.consultantid = this.consultantid;
		if (resourceid) {
			modal.componentInstance.load(resourceid);
		}
		modal.result.then((newItem: ConsultantResource) => {
			this.load();
		}).catch(() => { });
	}

}
